"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Chip_1 = require("@material-ui/core/Chip");
var MenuItem_1 = require("@material-ui/core/MenuItem");
var Paper_1 = require("@material-ui/core/Paper");
var TextField_1 = require("@material-ui/core/TextField");
var Typography_1 = require("@material-ui/core/Typography");
var Cancel_1 = require("@material-ui/icons/Cancel");
var classnames_1 = require("classnames");
var React = require("react");
function NoOptionsMessage(props) {
    return (React.createElement(Typography_1.default, tslib_1.__assign({ color: 'textSecondary', className: props.selectProps.classes.noOptionsMessage }, props.innerProps), props.children));
}
function inputComponent(_a) {
    var inputRef = _a.inputRef, props = tslib_1.__rest(_a, ["inputRef"]);
    return React.createElement("div", tslib_1.__assign({ ref: inputRef }, props));
}
function Control(props) {
    return (React.createElement(TextField_1.default, tslib_1.__assign({ fullWidth: true, InputProps: {
            inputComponent: inputComponent,
            inputProps: tslib_1.__assign({ className: props.selectProps.classes.input, inputRef: props.innerRef, children: props.children }, props.innerProps),
        } }, props.selectProps.textFieldProps)));
}
function Option(props) {
    return (React.createElement(MenuItem_1.default, tslib_1.__assign({ buttonRef: props.innerRef, selected: props.isFocused, component: 'div', style: {
            fontWeight: props.isSelected ? 500 : 400,
        } }, props.innerProps), props.children));
}
function Placeholder(props) {
    return (React.createElement(Typography_1.default, tslib_1.__assign({ color: 'textSecondary', className: props.selectProps.classes.placeholder }, props.innerProps), props.children));
}
function SingleValue(props) {
    return (React.createElement(Typography_1.default, tslib_1.__assign({ className: props.selectProps.classes.singleValue }, props.innerProps), props.children));
}
function ValueContainer(props) {
    return React.createElement("div", { className: props.selectProps.classes.valueContainer }, props.children);
}
function MultiValue(props) {
    var _a;
    return (React.createElement(Chip_1.default, { tabIndex: -1, label: props.children, className: classnames_1.default(props.selectProps.classes.chip, (_a = {},
            _a[props.selectProps.classes.chipFocused] = props.isFocused,
            _a)), onDelete: props.removeProps.onClick, deleteIcon: React.createElement(Cancel_1.default, tslib_1.__assign({}, props.removeProps)) }));
}
function Menu(props) {
    return (React.createElement(Paper_1.default, tslib_1.__assign({ square: true, className: props.selectProps.classes.paper }, props.innerProps), props.children));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer,
};
exports.default = components;
//# sourceMappingURL=components.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Autocomplete/components.js
// module id = 794
// module chunks = 58